import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";

import { registerTokenGetter } from "./clerk";

// Bridges Clerk's hook-only `getToken` into the non-React `getAuthToken()`
// helper that api.ts / GameContext.tsx (SSE pump) call. Mounted once
// inside <ClerkProvider>; unregisters on unmount so HMR doesn't leak a
// dead getter.
export default function TokenBridge() {
  const { getToken } = useAuth();
  useEffect(() => {
    registerTokenGetter(() => getToken());
    return () => registerTokenGetter(null);
  }, [getToken]);
  return null;
}
